import React from "react";
import { Menu, Button } from "antd";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import logo from "../../assets/images/logo.png";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const history = useHistory();

  // Icons
  const dashboardIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z" fill={color}></path>
      <path d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z" fill={color}></path>
      <path d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z" fill={color}></path>
    </svg>
  );

  const tablesIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z" fill={color}></path>
      <path fillRule="evenodd" clipRule="evenodd" d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z" fill={color}></path>
    </svg>
  );

  const billingIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z" fill={color}></path>
      <path fillRule="evenodd" clipRule="evenodd" d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z" fill={color}></path>
    </svg>
  );

  const profileIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z" fill={color}></path>
    </svg>
  );

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    history.push("/sign-in");
  };
  const menuItems = [
    {
      key: "dashboard",
      label: "Dashboard",
      path: "/dashboard",
      icon: dashboardIcon,
    },
    {
      key: "team_management",
      label: "Team Management",
      path: "/team_management",
      icon: tablesIcon,
    },
    {
      key: "workspaces",
      label: "Workspaces",
      path: "/workspaces",
      icon: tablesIcon,
    },
    {
      key: "workspace_subscriptions",
      label: "Workspace Subscriptions",
      path: "/workspace_subscriptions",
      icon: billingIcon,
    },
    {
      key: "integration_health",
      label: "Integration Health",
      path: "/integration_health",
      icon: tablesIcon,
    },
    {
      key: "user_management",
      label: "User Management",
      path: "/user_management",
      icon: tablesIcon,
    },
    {
      key: "subscription_plans",
      label: "Subscription Plans",
      path: "/subscription_plans",
      icon: billingIcon,
    },
    {
      key: "polars_quota_requests",
      label: "Smart AI Summary Quota Requests",
      path: "/polars_quota_requests",
      icon: billingIcon,
    },
    {
      key: "ai_providers",
      label: "AI Providers",
      path: "/ai_providers",
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M5 4C3.89543 4 3 4.89543 3 6V8C3 9.10457 3.89543 10 5 10H15C16.1046 10 17 9.10457 17 8V6C17 4.89543 16.1046 4 15 4H5ZM6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8H13C13.5523 8 14 7.55228 14 7C14 6.44772 13.5523 6 13 6H10Z" fill={color}/>
          <path fillRule="evenodd" clipRule="evenodd" d="M5 12C3.89543 12 3 12.8954 3 14V16C3 17.1046 3.89543 18 5 18H15C16.1046 18 17 17.1046 17 16V14C17 12.8954 16.1046 12 15 12H5ZM6 15C6.55228 15 7 14.5523 7 14C7 13.4477 6.55228 13 6 13C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15ZM10 14C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14H10Z" fill={color}/>
        </svg>
      ),
    },
    {
      key: "ai_provider_management",
      label: "AI Provider Management",
      path: "/ai_provider_management",
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 2C9.44772 2 9 2.44772 9 3V3.5H7C5.89543 3.5 5 4.39543 5 5.5V13.5C5 14.6046 5.89543 15.5 7 15.5H8V16.5C8 17.0523 8.44772 17.5 9 17.5H11C11.5523 17.5 12 17.0523 12 16.5V15.5H13C14.1046 15.5 15 14.6046 15 13.5V5.5C15 4.39543 14.1046 3.5 13 3.5H11V3C11 2.44772 10.5523 2 10 2Z" fill={color}/>
          <circle cx="8" cy="8" r="1" fill="white"/>
          <circle cx="12" cy="8" r="1" fill="white"/>
          <path d="M8 11.5C8 11.5 8.5 12.5 10 12.5C11.5 12.5 12 11.5 12 11.5" stroke="white" strokeWidth="1" strokeLinecap="round"/>
          <path d="M3 8H5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M15 8H17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
    },
  ];

  return (
    <>
      <div className="brand">
        <img src={logo} alt="logo" />
      </div>
      <hr />
      <Menu theme="light" mode="inline" selectedKeys={[page]}>
        {menuItems.map(item => (
            <Menu.Item key={item.path.replace("/", "")}>
              <NavLink to={item.path}>
                <span className="icon">{item.icon}</span>
                <span className="label">{item.label}</span>
              </NavLink>
            </Menu.Item>
          ))}

        <Menu.Item className="menu-item-header" key="account-pages">
          Account Pages
        </Menu.Item>

        <Menu.Item key="profile">
          <NavLink to="/profile">
            <span className="icon">{profileIcon}</span>
            <span className="label">Profile</span>
          </NavLink>
        </Menu.Item>
      </Menu>


      {/* Logout at bottom */}
      <div className="aside-footer" style={{ position: "absolute", bottom: "20px", width: "90%", padding: "0 16px" }}>
        <Button type="primary" danger block onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </>
  );
}

export default Sidenav;